import React from 'react';

import { homePageContent } from '../../../data';

import { Btn } from '../shared/Btn';
import { ComponentFader } from '../shared/ComponentFader';

import { Arrow } from '../../icons/Arrow';

import '../../../css/components/home-page/home-page-content.scss';
export function HomePageContent() {
  const contentSections = homePageContent.map((section, index) => {
    return (
      <ContentSection { ...section } key={ index } />
    )
  })
  return (
    <div className="home-page-content">
      <ComponentFader>
        <div className="home-page-text">
          <div className="header">
            Feel Good Text.
          </div>
          <div className="content">
            Some Times when I'm hungry I eat. Some Times when I'm hungry I eat. Some Times when I'm hungry I eat.
          </div>  
        </div>
      </ComponentFader>
      
      <ComponentFader>
        <div className="sections-wrapper">
          { contentSections }
        </div>
      </ComponentFader>
    </div>
  )
}

function ContentSection(props) {
  console.log(props);
  return (
    <div className="content-section">
        <div className="header">
          { props.header }
        </div>
        { props.icon }
        <div className="text">
          { props.text }
        </div>
        <Btn className="learn-more" to={ props.url }>
          {/* LEARN MORE <img src="images/icons/arrow-right-black.svg"/> */}
          LEARN MORE <Arrow/>
        </Btn>
      </div>
  )
}